






















































































































































































































import { Component, Prop } from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import {downloadUrls, TaskDetail} from '@/types/Task'
import { getAllTasks, deleteTask, cancelTask } from '@/request/apis/TaskManagementRequest'
import { getDownloadData } from '@/request/apis/common'
import { getSocket } from "@/socket.io"
import { PushDetail } from "@/types/Message"

@Component
export default class TaskManagementList extends RouterHelper {
  @Prop({ default: true }) showPager!: boolean
  @Prop({ default: 20 }) pageSize!: number

  private taskList: any[] = []
  private downloadList: downloadUrls = {
    params_download: ''
  }
  private total: number = 0
  private currentPage: number = 1
  private moduleList: string[] = ['showAll', 'ConvertFastq', 'PreProcessing', 'DataIntegration', 'Clustering', 'DifferentialExpression', 'CellTypeAnnotation', 'TrajectoryAnalysis', 'AdvancedDownstreamAnalysis', 'GeneSetEnrichment', 'CellCommunication', 'InferCNV']
  private statusList: string[] = ['showAll', 'complete', 'error', 'running']
  private timeList: string[] = ['showAll', 'twentyFourHours', 'fiveDays']
  private module: string = 'showAll'
  private taskStatus: string = 'showAll'
  private createTime: string = 'showAll'
  private finishListener!: Function

  /**
   * 查看任务详情
   * @param taskDetail 任务信息
   */
  private checkTask (taskDetail: TaskDetail) {
    this.$router.push(`${taskDetail.module}/result/${taskDetail.job_id}`)
  }

  /**
   * 删除任务
   * @param taskDetail 任务信息
   * @param index 当前这条记录索引
   */
  private async deleteData (taskDetail: TaskDetail, index: number) {
    const msg = this.$t('task.deleteConfirmContent')
    const title = this.$t('task.deleteConfirmTitle')
    try {
      await this.$confirm(<string>msg, <string>title, { type: 'warning' })
      await deleteTask(null, taskDetail.job_id).start()
      this.taskList.splice(index, 1)
    } catch (e) {
      console.warn(e)
    }
  }

  // 根据job id获取下载链接
  private async getDownloadData(id: string) {
    this.downloadList = {params_download: ''}
    this.downloadList = await getDownloadData(null, id).start()
  }

  /**
   * 根据筛选情况获取任务列表，默认显示所有
   * @param index 当前页数
   */
  private async getTaskList (index: number = 1) {
    try {
      const listData = await getAllTasks(null, {
        module: this.module,
        task_status: this.taskStatus,
        create_time: this.createTime,
        page_size: this.pageSize,
        page_index: this.currentPage
      }).start()
      this.taskList = listData.tasks
      this.total = listData.total
    } catch (e) {
      console.warn(e)
    }
  }

  /**
   * 根据id取消任务
   * @param taskDetail 任务详情
   */
  private async cancelHandler (taskDetail: TaskDetail) {
    try {
      await cancelTask(null,taskDetail.job_id).start()
      taskDetail.status = 'error'
    } catch (e) {
      console.warn(e)
    }
  }

  /**
   * 根据监听的推送消息更新任务列表
   */
  private addSocketListener () {
    let socket = getSocket()
    if (!socket) return
    // 监听到推送消息再刷新列表
    socket.on('job_start',(msgDetail: PushDetail) => {
      this.taskList.unshift(msgDetail)
      this.taskList[0].status = 'running'
      this.taskList[0].module = msgDetail.category
      this.taskList[0].job_id = msgDetail.id
    })
    this.finishListener = (msgDetail: PushDetail) => {
      // 遍历job_id判断刚刚完成的任务是否在当前页上，在即刷新
      for(let item of this.taskList) {
        if (item.job_id === msgDetail.id && msgDetail.type !== 'error') {
          item.status = 'complete'
          item.run_time = msgDetail.run_time
          item.data_download = msgDetail.data_download
          break
        }
      }
    }
    socket.on('job_finish', this.finishListener)
  }

  private mounted () {
    this.getTaskList()
    this.addSocketListener()
  }

  private destroyed () {
    const socket = getSocket()
    socket.off('job_start')
    socket.off('job_finish', this.finishListener)
  }

}
